export const definedTranslation = {
  collections: {
    materialText: {
      id: 'collections-material-text',
      defaultMessage: 'material',
    },
    materialsText: {
      id: 'collections-materials-text',
      defaultMessage: 'materials',
    },
  },
};
